module.exports = __webpack_public_path__ + "img/botnet.c6bc300f.png";